import styled from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';
import { site } from '@panel/commons/helpers';

const siteId = site.id;
const isBR = siteId.includes('BR');
const siteWithBanner = isBR;

const WrapperBackground = styled.div`
  background-color: ${({ device }) => select(device === 'mobile' ? 'white' : 'lightGray')};
  height: 100vh;
  width: 100%;
  min-height: calc(100vh - ${siteWithBanner ? '90' : '61'}px);
  padding: ${({ device }) => (device === 'mobile' ? '0' : '24px 0')};
  @media (max-width: 1200px) {
    margin-top: ${siteWithBanner ? '90' : '61'}px;
  }
`;

const Container = styled.div`
  width: ${({ device }) => {
    if (device === 'mobile') return '100%';
    if (device === 'tablet') return '546px';
    return '620px';
  }};
  background-color: ${select('white')};
  margin: auto;
  padding: ${({ device }) => (device === 'mobile' ? '16px 24px' : '32px')};
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const CtaContainer = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: center;
`;

const ImgCheck = styled.img`
  align-self: center;
  margin-bottom: 8px;
  width: ${({ device }) => (device === 'mobile' ? '106px' : '122px')};
  height: ${({ device }) => (device === 'mobile' ? '106px' : '122px')};
`;

const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

const Title = styled.div`
  width: ${({ device }) => (device === 'mobile' ? '280px' : isBR ? '340px' : 'auto')};
  font-family: Hind;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  text-align: center;
  color: ${select('midDarkGreen')};
  margin-bottom: ${({ device }) => (device === 'mobile' ? '16px' : '8px')};
  padding: 0 30px;
  white-space: break-spaces;
`;

const Subtitle = styled.div`
  font-family: Hind;
  font-weight: 400;
  font-size: 16px;
  max-width: 100%;
  line-height: 24px;
  text-align: center;
  white-space: break-spaces;
  padding: 0px 10px;
  width: ${() => (isBR ? '398px' : 'auto')};
`;

const CTA = styled.button`
  width: ${({ device }) => (device === 'mobile' ? '100%' : 'auto')};
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${getColor('primary')};
  padding: 0px 12px;
  font-family: Hind;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  cursor: pointer;
  :hover {
    background-color: ${getColor('tertiary')};
  }
  &.PRINCIPAL {
    background-color: ${getColor('primary')};
    color: ${select('white')};
    :hover {
      background-color: ${getColor('secondary')};
    }
  }
`;

const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: rgb(256, 256, 256, 0.6);
  z-index: 200;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export { WrapperBackground, Container, CTA, LoaderWrapper, ImgCheck, TextContainer, Title, Subtitle, CtaContainer };
